import {Injectable} from '@angular/core';
import {MatDialogRef} from '@angular/material/dialog';
import {MatSnackBar} from "@angular/material/snack-bar";

/** Simple service that makes interaction with {@link MatSnackBar} easier */
@Injectable({
	providedIn: 'root'
})
export class SnackbarService {

	public static dictationDialogRef:MatDialogRef<any, any>;

	constructor(private snackbar:MatSnackBar) {
	}

	/**
	 * Show an error message to the user with an "ok" button
	 * @param message the message to show
	 */
	error(message:string) {
		this.snackbar.open(message, "Ok", {duration: 60000});
	}

	/**
	 * Show a message to the user in the snack bar for a short amount of time
	 * @param message the message to show
	 * @param action the label for the snackbar action button
	 * @param duration show a message to the user in the snack bar for a short amount of time (ms)
	 */
	message(message:string, action?:string, duration:number = 5000) {
		this.snackbar.open(message, action, {duration});
	}
}
